export const BOOKING_LINK =
    "https://book.travelbookgroup.com/premium/index.html?id_albergo=22569&dc=8150&lingua_int=eng&id_stile=17107"
export const EMAIL_JS_USER = "user_dCnCF0QUgFeYYfY9mjZWx"
export const MEETINGS_AND_EVENTS_TEMPLATE_ID = "template_05fodjy"
export const WEDDINGS_TEMPLATE_ID = "template_r9lf7im"
